import axios from 'axios';
import { HOOK_URL } from '../constants';

export const callHook = async <T, U>(hookId: string, data: T): Promise<U> => {
    const headersList = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };

    const reqOptions = {
        url: `${HOOK_URL}/${hookId}`,
        method: 'POST',
        headers: headersList,
        data: JSON.stringify(data),
    };

    const answer = await axios.request(reqOptions);
    return answer.data as U;
};
